import React from 'react';
import { Flex, styled, Text } from '@100mslive/roomkit-react';
import logo from '../images/incruiter-logo.svg';
const PostLeave = () => {
    return (
        <Flex direction="column" css={{ height: '100vh', width: '100vw' }}>
            <Flex
                justify="center"
                direction="column"
                align="center"
                css={{ bg: '#191924', flex: '1 1 0', position: 'relative' }}
            >
                <LogoImg src={logo} alt="Company Logo" width={264} height={108} />
                <br />
                <Text
                    variant="body1"
                    css={{
                        color: '#ffffff',
                        fontWeight: '$regular',
                        'font-size': '30px',
                        'line-height': '41px',
                        textAlign: 'center',
                        '@sm': { 'font-size': '24px', 'line-height': '30px' },
                    }}
                >
                    The meeting has been ended.
                </Text>
            </Flex>
        </Flex>
    );
};
const LogoImg = styled('img', {
    p: '$2',
    objectFit: 'contain',
});

export default PostLeave;
